import React, { useState } from 'react';
import icons from "../../../assets/images/constantIcons";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useFormik } from "formik";
import * as Yup from "yup";
import images from '../../../assets/images/constantImages';
import { handleError } from '../../Common/ApiCommon/ApiService';
import { createOrder } from '../../CanteenUsers/OrderSlice';
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';

const CreateOrder = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [cartItems, setCartItems] = useState(() => {
        const stored = localStorage.getItem("cart");
        return stored ? JSON.parse(stored) : ""
    })
    const canteenUserId = localStorage.getItem('userId');

    const formik = useFormik({
        initialValues: {
            full_name: "",
            mobile_no: "",
            payment_mode: "",
        },

        validationSchema: Yup.object({
            full_name: Yup.string()
                .trim()
                .matches(
                    /^[A-Za-z\s]+$/,
                    "Full name cannot contain numbers or special characters"
                )
                .min(2, "Full name must be at least 2 characters")
                .max(25, "Full name cannot exceed 25 characters")
                .required("Full name is required"),
            mobile_no: Yup.string()
                .required("Mobile number is required"),
            payment_mode: Yup.string().required("Payment mode is required"),

        }),
        onSubmit: async (values) => {
            const orderItems = Object.values(cartItems).map(item => ({
                item_id: item.id,
                quantity: item.quantity
            }));

            const payload = {
                canteen_user_id: parseInt(canteenUserId),
                order: {
                    full_name: values.full_name,
                    mobile_no: values.mobile_no,
                    total_price: totalPrice,
                    payment_method: values.payment_mode,
                    order_items: orderItems
                }
            };
            try {
                const response = await dispatch(createOrder(payload)).unwrap();
                console.log("res", response);
                toast.success(response.message, { duration: 2000 });
                localStorage.removeItem("cart");
                setCartItems({});
                setTimeout(() => {
                    navigate("/mainDashboard/dashboardCt");
                }, 1000)

            } catch (errors) {
                handleError(errors);
            }
        },

    });
    const updateLocalStorage = (updatedCart) => {
        setCartItems(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
    };

    const handleIncrease = (itemId) => {
        const updated = { ...cartItems };
        if (updated[itemId]) {
            updated[itemId].quantity += 1;
        }
        updateLocalStorage(updated);
    };

    const handleDecrease = (itemId) => {
        const updated = { ...cartItems };
        if (updated[itemId]) {
            if (updated[itemId].quantity === 1) {
                delete updated[itemId];
            } else {
                updated[itemId].quantity -= 1;
            }
        }
        updateLocalStorage(updated);
    };
    const totalPrice = Object.values(cartItems).reduce((total, item) => {
        return total + (parseFloat(item.price) * item.quantity);
    }, 0);

    return (
        <div className="py-4 px-6">
            <div className="flex items-center mb-4 text-G300 cursor-pointer">
                <icons.FaArrowLeftLong onClick={() => navigate(-1)} className="text-2xl mr-2" />
                <span className="text-md">Back</span>
            </div>
            <p className='text-G800 text-xl font-semibold mb-3'>Create Order</p>
            <form onSubmit={formik.handleSubmit} className="space-y-4 text-start md:w-2/4">
                <div className='flex gap-3'>
                    {/* Full Name */}
                    <div className="text-G300 w-1/2">
                        <label className="block text-sm mb-2">Full Name <span className="text-red ">*</span></label>
                        <input
                            type="text"
                            name="full_name"
                            value={formik.values.full_name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="inputtext"
                            placeholder="Full Name"
                        />
                        {formik.errors.full_name && formik.touched.full_name && (
                            <div className="text-red text-sm">
                                {formik.errors.full_name}
                            </div>
                        )}
                    </div>
                    {/* Mobile Number */}
                    <div className="text-G300 w-1/2">
                        <label className="block text-sm mb-2">Mobile Number <span className="text-red ">*</span></label>
                        <PhoneInput
                            country={'in'}
                            value={formik.values.mobile_no}
                            onChange={(value) => formik.setFieldValue('mobile_no', value)}
                            onBlur={formik.handleBlur}
                            disableDropdown
                            enableSearch={false}
                            countryCodeEditable={false}
                            onlyCountries={['in']}
                            placeholder="80679 35463"
                            inputProps={{
                                name: 'mobile_no',
                                required: true,
                                className: 'w-full inputtext pl-2',
                            }}
                            buttonStyle={{ display: 'none' }}
                        />
                        {formik.errors.mobile_no && formik.touched.mobile_no && (
                            <div className="text-red text-sm">
                                {formik.errors.mobile_no}
                            </div>
                        )}
                    </div>
                </div>
                <div className=''>
                    <p className='text-G800 text-lg font-medium mb-2'>Items</p>
                    <div className='flex flex-col gap-2 bg-white p-2 rounded-md'>
                        {Object?.values(cartItems)?.map((item, i) => (
                            <div key={i} className="flex justify-between items-center">
                                <div className="flex items-center gap-6">
                                    <img src={`https://headquater.pixoatic.com${item.image}`} alt={item.name} className="w-12 h-12 md:w-16 md:h-14 rounded-full" />
                                    <div>
                                        <p className="text-base lg:text-lg font-medium text-G800">{item.name}</p>
                                        <p className="text-sm text-G500">X{item.quantity}</p>
                                    </div>
                                </div>
                                <div className="text-right">
                                    <p className="text-sm font-semibold mb-1">₹ {(parseFloat(item.price) * item.quantity).toFixed(2)}</p>
                                    <div className="flex items-center border border-canteengreen  rounded-md">
                                        <button onClick={() => handleDecrease(item.id)} className="px-2 text-canteengreen text-xl">−</button>
                                        <span className="px-2">{item.quantity}</span>
                                        <button onClick={() => handleIncrease(item.id)} className="px-2 text-canteengreen text-xl">+</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className='flex justify-between text-G800 text-xl font-bold mt-2'><p className=''>Total</p><p>₹ {totalPrice}</p></div>
                        <hr className='border-b border-b-slate-400 border-dashed my-1 last:border-b-0' />
                        <div className='flex justify-between items-center'>
                            <p className='text-G800 text-sm lg:text-lg font-semibold'>Missing something ?</p>
                            <Link to={`/mainDashboard/menusList`}>
                                <button className='flex items-center px-3 bg-black text-white rounded-md py-1 text-sm md:text-base font-medium'>
                                    <icons.FaPlus className='pr-2' /> Add More Items
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className='pb-5'>
                    <p className='text-G800 text-lg font-medium mb-2'>Payment mode</p>
                    <div className='flex gap-5 text-G300 font-medium text-sm'>
                        <p>
                            <input
                                type="radio"
                                id="onlinepay"
                                name="payment_mode"
                                value="online_payment"
                                onChange={formik.handleChange}
                                checked={formik.values.payment_mode === "online_payment"}
                            />
                            <label htmlFor="onlinepay" className='pl-3'>Online Payment</label>
                        </p>
                        <p>
                            <input
                                type="radio"
                                id="cash"
                                name="payment_mode"
                                value="cash"
                                onChange={formik.handleChange}
                                checked={formik.values.payment_mode === "cash"}
                            />
                            <label htmlFor="cash" className='pl-3'>Cash</label>
                        </p>
                        {formik.errors.payment_mode && formik.touched.payment_mode && (
                            <div className="text-red text-sm">
                                {formik.errors.payment_mode}
                            </div>
                        )}
                    </div>
                </div>
                <button className='text-lg bg-green text-white w-full py-1 text-center rounded-md'>Create Order</button>
            </form>
        </div>
    )
}

export default CreateOrder;